import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
  Avatar,
  Divider,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { mainNavbarItems } from "./consts/navbarItems";
import { navbarStyles } from "./styles";

const NavbarDesktop = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const getUrl = location.pathname + location.search;

  return (
    <Drawer sx={navbarStyles.desktopDrawer} variant="permanent" anchor="left">
      <List>
        <ListItem sx={{ justifyContent: "center" }}>
          <Avatar
            src="/assets/logo/bianco.png"
            sx={{ width: 225, height: 225, borderRadius: 0 }}
          />
        </ListItem>
        <Divider sx={navbarStyles.divider} />
        {mainNavbarItems.map((item, index) => (
          <ListItem
            key={index}
            button
            onClick={() => navigate(item.route)}
            sx={{ color: getUrl === item.route ? "#cc5500" : "#767689", mt: 1 }}
          >
            <ListItemIcon
              sx={{ color: getUrl === item.route ? "#cc5500" : "#767689" }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default NavbarDesktop;
